<template>
    <div class="row">
        <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
        
        <div class="d-none d-lg-block col-lg-2"></div>
        <div class="col-12 col-lg-8">
            <h1>District User Management</h1>
            <p>This page allows you to assign a user to a district, and grant the rights to manage the district's students, 
                or make the user a manager of the district.</p>

            <div class="mb-2">
                <select class="form-select me-2" aria-label="District select" v-model="districtSelected" @change="getUsers">
                    <option v-for="d in districts" :value="d.id">{{ d.name }}</option>
                </select>
            </div>

            <div class="mb-2">
                <div class="list-group">
                    <div v-for="s in staff" class="list-group-item">
                        <admin-dist-users-row 
                            :user="s"
                            :value="s.user_district_status"
                            :key="`user-${s.id}`"
                            @delete="deleted"
                        >
                        </admin-dist-users-row>
                    </div>
                </div>
            </div>

            <multiselect
                v-model="staffSelected"
                :searchable="true"
                :options="staffAvailable"
                :multiple="false"
                :loading="isLoading"
                :options-limit="10"
                :internal-search="false"
                :clear-on-select="true" 
                :close-on-select="true" 
                :custom-label="staffLabel"
                placeholder="Select user..."
                track-by="id"
                label="name"
                @search-change="staffSearch"
                @select="addStaff"
            ></multiselect>
            <div class="mt-4">
                <home-button></home-button>
            </div>
        </div>

    </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import Multiselect from 'vue-multiselect';

import HomeButton from './HomeButton.vue';
import AdminDistUsersRow from './AdminDistUsersRow.vue';

export default {
    components: { Loading, Multiselect, HomeButton, AdminDistUsersRow },

    data() {
        return {
            isLoading: false,
            districts: [],
            staff: [],
            
            districtSelected: null,
            staffSelected: [],
            staffAvailable: [],
            
        };
    },

    mounted() {
        this.isLoading = true;
        axios
            .get('/api/admin/districts')
            .then(response => {
                this.districts = response.data;
                this.districtSelected = this.districts[0].id;
                this.getUsers();
            })
            .catch(error => {
                console.error(error);
            })
            .finally(() => {
                this.isLoading = false;
            });
    },

    methods: {
        getUsers: function() {
            this.isLoading = true;
            axios
                .get(`/api/admin/districts/${this.districtSelected}/users`)
                .then(response => {
                    console.log(response.data);
                    this.staff = response.data
                })
                .catch(error => {
                    console.error(error);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        
        staffSearch: function(text = '') {
            if (text.length < 1) {
                return;
            } else {
                this.isLoading = true;
                axios
                    .get(`/api/admin/users?search=${text}&limit=10`)
                    .then(response => {
                        this.staffAvailable = response.data;
                    })
                    .catch(error => {
                        console.error(error);
                    })
                    .finally(() => {
                        this.isLoading = false;
                    });
            }
        },

        staffLabel: function(staff) {
            if (staff.name && staff.email) {
                return `${staff.name} (${staff.email})`;
            } else {
                return 'Search...';
            }
        },

        addStaff: function() {
            this.isLoading = true;

            const data = {
                user: this.staffSelected.id,
                district: this.districtSelected,
                status: 1,
            };

            axios
                .post(`/api/admin/districts/users`, data)
                .then(response => {
                    this.staffSelected = [];
                    this.getUsers();
                })
                .catch(error => {
                    console.error(error);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        deleted: function(event) {
            this.staff = this.staff.filter(user => user.id != event);
        }
    },
}
</script>